$(document).ready(function(){
$('.review-cards').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      prevArrow: $(".review-left"),
      nextArrow: $(".review-right"),
      responsive: [
        {
              breakpoint: 1023,
              settings: {
                slidesToShow: 2
              }
          },
          {
              breakpoint: 749,
              settings: {
                slidesToShow: 1
              }
          }
      ]
  })

})